var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 52,
    viewBox: "0 0 60 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_478_9218)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.7592 18.4014L20.9627 22.2751L22.3961 22.9398L24.1926 19.0661L22.7592 18.4014Z",
    fill: "#28345A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1976 20.426L22.7852 21.3149L25.3704 22.5144L25.7829 21.6255L23.1976 20.426Z",
    fill: "#28345A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2092 18.5299V29.9999H22.3392L20.4592 24.6299C20.0792 23.5499 19.0592 22.8199 17.9092 22.8199H17.8592C16.7492 22.8199 15.7492 22.1799 15.2692 21.1899L14.7892 20.1699C14.3192 19.1699 13.3092 18.5399 12.1992 18.5399L12.2092 18.5299Z",
    fill: "#28345A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2792 19.4099L32.2592 29.4599H26.6192L24.9492 25.2599C24.8192 24.9399 24.7692 24.5899 24.7992 24.2399C24.8992 23.0799 25.3492 20.4399 27.2792 19.4099Z",
    fill: "#28345A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7903 35.47L25.7903 10.63C25.7903 10.63 23.8503 5.91996 19.2403 4.47996C18.6503 4.28996 18.0203 4.20996 17.4003 4.20996H6.07031V25.48H9.12031V7.77996H16.5903C17.9303 7.77996 19.2603 8.17996 20.3403 8.97996C21.1003 9.54996 21.9103 10.34 22.4803 11.41L34.9503 36.51H37.1503C37.6803 36.51 38.0303 35.95 37.8003 35.48L37.7903 35.47Z",
    fill: "#CCE5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1209 25.8101H29.6309L31.2009 28.9601H34.6409L33.1209 25.8101Z",
    fill: "#CCE5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.12031 22.3601H6.07031V25.4801H9.12031V22.3601Z",
    fill: "#CCE5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.46 26.86L17.6 27.17C18.09 28.26 19.18 28.97 20.37 28.97H34.58L38.29 36.52V43.02C38.29 44.6 37.01 45.87 35.44 45.87H2.85C1.28 45.86 0 44.58 0 43V27.91C0 26.34 1.28 25.06 2.85 25.06H14.68C15.88 25.06 16.96 25.76 17.45 26.86H17.46Z",
    fill: "#CCE5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 43C0 44.58 1.28 45.85 2.85 45.85H35.43C37.01 45.85 38.28 44.57 38.28 43V36.5H0V43Z",
    fill: "#027BC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.40969 51.3901C12.4362 51.3901 14.8897 48.9142 14.8897 45.8601C14.8897 42.8059 12.4362 40.3301 9.40969 40.3301C6.38317 40.3301 3.92969 42.8059 3.92969 45.8601C3.92969 48.9142 6.38317 51.3901 9.40969 51.3901Z",
    fill: "#28345A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.40999 48.02C10.5974 48.02 11.56 47.0529 11.56 45.86C11.56 44.6671 10.5974 43.7 9.40999 43.7C8.22258 43.7 7.25999 44.6671 7.25999 45.86C7.25999 47.0529 8.22258 48.02 9.40999 48.02Z",
    fill: "#027BC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7495 51.3901C29.7761 51.3901 32.2295 48.9142 32.2295 45.8601C32.2295 42.8059 29.7761 40.3301 26.7495 40.3301C23.723 40.3301 21.2695 42.8059 21.2695 45.8601C21.2695 48.9142 23.723 51.3901 26.7495 51.3901Z",
    fill: "#28345A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7496 48.02C27.937 48.02 28.8996 47.0529 28.8996 45.86C28.8996 44.6671 27.937 43.7 26.7496 43.7C25.5622 43.7 24.5996 44.6671 24.5996 45.86C24.5996 47.0529 25.5622 48.02 26.7496 48.02Z",
    fill: "#027BC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2105 41.61V0H40.0605V43.22C40.0605 44.68 41.2405 45.86 42.7005 45.86L59.5405 45.91V42.76H44.3805C43.7405 42.76 43.2205 42.24 43.2205 41.6L43.2105 41.61Z",
    fill: "#027BC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0495 26.9099H44.7695V41.1899H59.0495V26.9099Z",
    fill: "#CCE5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4187 26.9099H50.3887V31.2699H53.4187V26.9099Z",
    fill: "#019EF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0495 39.6599H44.7695V41.1799H59.0495V39.6599Z",
    fill: "#027BC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0495 11.0601H44.7695V25.3401H59.0495V11.0601Z",
    fill: "#CCE5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4187 11.0601H50.3887V15.4201H53.4187V11.0601Z",
    fill: "#019EF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0495 23.8101H44.7695V25.3301H59.0495V23.8101Z",
    fill: "#027BC7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_478_9218"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59.53,
    height: 51.39,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStock);
export default __webpack_public_path__ + "static/media/stock.74be11d6ac9de64422ca278fc7f20a94.svg";
export { ForwardRef as ReactComponent };